import { Component, ElementRef } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { InternalAnalyticsService } from '@shared/services/internalAnalytics.service';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { LinkService } from '@shared/services/link.service';
import { AuthenticationService } from '@shared/services/authentication.service';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CourseViewBaseComponent } from '@shared/base-components/course-view.base.component';
import { PaginatedScrollService } from '@shared/services/paginated-scroll.service';

@Component({
  selector: 'course-view',
  templateUrl: './course-view.component.html',
  styleUrls: ['./course-view.component.scss'],
  animations: fuseAnimations
})
export class CourseViewComponent extends CourseViewBaseComponent {
  constructor(
    protected _router: Router,
    protected _activatedRoute: ActivatedRoute,
    protected _currentHubService: CurrentHubService,
    protected _internalAnalyticsService: InternalAnalyticsService,
    protected _linkService: LinkService,
    protected el: ElementRef,
    protected _courseApiService: CoursesAPIService,
    protected _dialog: MatDialog,
    protected _authService: AuthenticationService,
    protected _paginatedScrollService: PaginatedScrollService
  ) {
    super(_router, _activatedRoute, _currentHubService, _internalAnalyticsService, _linkService, el, _courseApiService, _dialog, _authService, _paginatedScrollService);
  }
}
